import { getDate } from "../../utils/getStrDate";
import { numberWithSpaces } from "../../utils/numberWithSpaces";
import classNames from "classnames";
import { Text } from "../text/text";

import styles from  "./graph.module.css"

export const GraphItem = ({ height, value, date, type = null }) => {
    return (
        <div className={styles.graph_item}>
            <Text as="div" variant="tiny" className={styles.graph_item_suptitle} align="center">
                {numberWithSpaces(value)}
            </Text>
            <div style={{ flex: "1 1 auto", display: "flex", flexDirection: "column", justifyContent: "end" }}>
                <div className={classNames(styles.graph_item_thumb, styles[type])} style={{ height: `${Number(height * 100).toFixed(0)}%` }} />
            </div>
            <Text as="div" variant="tiny" className={styles.graph_item_subtitle} align="center">
                {getDate(date)}
            </Text>
        </div>
    );
}
